<!-- =========================================================================================
  File Name: StudentView.vue
  Description: Student View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="student-view-tab-study">
    <div>
      <vs-table v-model="selected" @selected="handleSelected" :data="history" stripe>
        <template slot="thead">
          <!-- <vs-th>브랜드</vs-th> -->
          <vs-th>번호</vs-th>
          <vs-th>코스</vs-th>
          <vs-th>레벨</vs-th>
          <vs-th>교재</vs-th>
          <vs-th>시작일</vs-th>
          <vs-th>학습일</vs-th>
          <vs-th>완료일</vs-th>
          <vs-th>진행율</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <!-- <vs-td :data="data[indextr].brandName">
              {{ data[indextr].brandName }}
            </vs-td> -->
            <vs-td :data="indextr + 1">
              {{ indextr + 1 }}
            </vs-td>

            <vs-td :data="data[indextr].courseName">
              {{ data[indextr].courseName }}
            </vs-td>

            <vs-td :data="data[indextr].levelName">
              {{ data[indextr].levelName }}
            </vs-td>
            
            <vs-td :data="data[indextr].bookName">
              {{ data[indextr].bookName }}
            </vs-td>

            <vs-td :data="data[indextr].assignDate">
              {{ data[indextr].assignDate.split(' ')[0] }}
            </vs-td>

            <vs-td :data="data[indextr].lastStudyDate">
              {{ displayLastStudyDate(data[indextr].lastStudyDate) }}
            </vs-td>

            <vs-td :data="data[indextr].finishDate">
              {{ data[indextr].finishDate }}
            </vs-td>

            <vs-td :data="data[indextr].progress">
              {{ data[indextr].progress }}%
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    
    <vs-divider class="mt-4 mb-4"></vs-divider>

    <div v-if="selected" class="mt-6">
      <div><p class="product-name font-medium ">{{selected.bookName}} ({{selected.progress}}%)</p></div>
      <div class="mb-4">
        <div class="flex justify-between">
          <small class="text-grey">0%</small>
          <small class="text-grey">100%</small>
        </div>
        <vs-progress :percent="selected.progress" class="block mt-1shadow-md"></vs-progress>
      </div>
      <vs-collapse type="border" accordion>
        <vs-collapse-item :key="index" v-for="(stepList, index) in studyResultList">
          <div slot="header">
            <div class="vx-row flex flex-wrap justify-between">
              <div class="vx-col flex w-1/2 h-12">
                <feather-icon icon="MenuIcon" svgClasses="w-5 h-5 stroke-current mr-1"/>
                <p class="mt-2">{{ displayUnitName(stepList.unit)}}</p>
              </div>
            </div>
          </div>

          <vs-table :data="stepList.schedule" stripe>
            <template slot="thead">
              <vs-th>순서</vs-th>
              <vs-th width="300px">Step</vs-th>
              <vs-th style="width: 30%">학습메뉴</vs-th>
              <vs-th>학습시간</vs-th>
              <vs-th>힌트사용</vs-th>
              <vs-th>학습일</vs-th>
              <vs-th>학습결과</vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <p class="product-name font-medium truncate">{{ indextr + 1}}</p>
                  </vs-td>

                  <vs-td>
                    <p class="product-name font-medium truncate">{{ tr.stepName }}</p>
                  </vs-td>

                  <vs-td>
                    <p >{{ tr.menuName }}</p>
                  </vs-td>

                  <vs-td>
                    <p class="product-name font-medium truncate">{{ displayTime(tr.studyTime) }}</p>
                  </vs-td>

                  <vs-td>
                    <p class="product-name font-medium truncate">{{ displayHintUseNum(tr.hintUseNum) }}</p>
                  </vs-td>

                  <vs-td>
                    <p class="product-name font-medium truncate">{{ displayStudyDate(tr.studyDate) }}</p>
                  </vs-td>

                  <vs-td>
                    <feather-icon v-if="tr.studyResultData" icon="SearchIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="showResultDetail(tr.studyResultData)"/>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vs-collapse-item>
      </vs-collapse>  

      <vs-popup
        title="학습결과"
        :active.sync="showMenuStudyResult">
        <div class="con-exemple-prompt">
          <vs-table :data="menuStudyResult" stripe>
            <template slot="thead">
              <vs-th>문제</vs-th>
              <vs-th>정답</vs-th>
              <vs-th>입력값</vs-th>
              <vs-th>결과</vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <p>{{ tr.question }}</p>
                  </vs-td>
                  <vs-td>
                    <p>{{ tr.answer }}</p>
                  </vs-td>
                  <vs-td>
                    <p>{{ tr.userAnswer }}</p>
                  </vs-td>
                  <vs-td>
                    <p :class="cssMenuStudyResult(tr.result)">{{ dispMenuStudyResult(tr.result) }}</p>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>
      </vs-popup>

    </div>
  </div>
</template>

<script>
import { fetchData } from '@/api/module'

export default {
  data () {
    return {
      selected: null,
      history: [],
      studentID: this.$route.params.studentID,
      studyResultList: [],
      showMenuStudyResult: false,
      menuStudyResult: []
    }
  },
  computed: {
    
  },
  methods: {
    dispMenuStudyResult (result) {
      if (result) {
        return '정답'
      } else {
        return '오답'
      }
    },
    cssMenuStudyResult (result) {
      if (result) {
        return 'text-primary'
      } else {
        return 'text-danger'
      }
    },
    displayUnitName (unit) {
      if (unit === null) return
      return unit.replace('U', 'Unit ')
    },
    showResultDetail (studyResultData) {
      this.menuStudyResult = JSON.parse(studyResultData)
      this.showMenuStudyResult = true
    },
    displayStudyDate (studyDate) {
      if (studyDate === null) return
      return studyDate.substring(0, 16)
    },
    displayLastStudyDate (studyDate) {
      if (studyDate === null) return
      return studyDate.substring(0, 10)
    },
    displayHintUseNum (hintUseNum) {
      if (hintUseNum === null) return
      return `${hintUseNum  }회`
    },
    displayTime (studyTime) {
      if (studyTime === null) return

      const min = studyTime / 60
      const second =  studyTime % 60
      return `${this.padLeft(parseInt(min), 2)}:${this.padLeft(parseInt(second), 2)}`
    },
    padLeft (nr, n, str) {
      return Array(n - String(nr).length + 1).join(str || '0') + nr
    },
    handleSelected (tr) {
      this.loadStudyResultList(tr.bookCode)
    },
    arrangeData (scheduleList) {
      
      let unitCode = ''
      let stepList = new Array()
      const unitList = new Array()
      for (let i = 0; i < scheduleList.length; i++) {
        if (unitCode !== scheduleList[i].unitCode) {
          unitCode = scheduleList[i].unitCode
          if (stepList.length > 0) {
            unitList.push({unit: stepList[0].unitCode, schedule: stepList.slice()})
            stepList = new Array()
          }
          stepList.push(scheduleList[i])
        } else {
          stepList.push(scheduleList[i])
        }
      }

      if (stepList.length > 0) {
        unitList.push({unit: stepList[0].unitCode, schedule: stepList.slice()})
      }
      return unitList
    },
    async loadBookHistory () {
      try {
        const {data} = await fetchData(`student/${this.studentID}/book-history`, {studentID : this.studentID})
        this.history = data.list
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async loadStudyResultList (bookCode) {
      try { 
        const params = {
          bookCode,
          userID: this.studentID
        }
        const { data } = await fetchData('/study-result', params)
        this.studyResultList = this.arrangeData(data.list)
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  created () {
    this.loadBookHistory()
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-student-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
